var React = require('react');

function Ghost (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M186.1.09C81 3.24 0 94.92 0 200.05V464a16 16 0 0 0 27.31 11.31l24.92-18.53A16 16 0 0 1 73.74 459l43 48.35a16 16 0 0 0 22.63 0L180 461.46a16 16 0 0 1 23.92 0l40.72 45.85a16 16 0 0 0 22.63 0L310.26 459a16 16 0 0 1 21.51-2.21l24.92 18.53C366.77 485.36 384 478.22 384 464V192C384 84 294.83-3.17 186.1.09zM128 224a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 0a32 32 0 1 1 32-32 32 32 0 0 1-32 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M128 160a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm128 0a32 32 0 1 0 32 32 32 32 0 0 0-32-32z","className":"fa-primary","key":2})]);
}

Ghost.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Ghost;

Ghost.default = Ghost;
